<template>
  {{{ loadingIndicator }}}
</template>

<script>
export default {
  name: 'LoadingView',
  data() {
    return {
        loadingIndicator: this.$root.config.loadingIndicator.html
    }
  }
}
</script>


// WEBPACK FOOTER //
// LoadingView.vue?080b15d5